import type { MetricDenominator, MetricNumerator } from "./types";

export interface MetricSource {
  shortLabel: string;
  description: string;
}

const REC_TABLE_DESCRIPTION =
  "Recommendations from this flow's recommendation table. Point-in-time snapshot — does not update if a recommendation is later dropped from sync.";

const SEND_EVENT_DESCRIPTION =
  "Send events from each channel's configured send event model.";

const MATCHED_DESCRIPTION =
  "Send events that were matched to a recommendation, sourced from each channel's configured send event model.";

const ROLLING_30D_USERS_DESCRIPTION =
  "Rolling 30-day count of active users from the audience.";

const ROLLING_7D_CHANNEL_REACH_DESCRIPTION =
  "Rolling 7-day count of unique users reached, per channel.";

export function getNumeratorSource(numerator: MetricNumerator): MetricSource {
  switch (numerator) {
    case "sends":
      return { shortLabel: "Sends", description: SEND_EVENT_DESCRIPTION };
    case "matched":
      return { shortLabel: "Matched sends", description: MATCHED_DESCRIPTION };
    case "recs":
      return {
        shortLabel: "Recommendations",
        description: REC_TABLE_DESCRIPTION,
      };
    case "rolling_7d_channel_reach":
      return {
        shortLabel: "Channel reach (7d)",
        description: ROLLING_7D_CHANNEL_REACH_DESCRIPTION,
      };
  }
  const column = numerator.slice("metadata.".length);
  return {
    shortLabel: column,
    description: `Values of \`${column}\` from each channel's configured send event model.`,
  };
}

export function getDenominatorSource(
  denominator: MetricDenominator,
): MetricSource | null {
  switch (denominator) {
    case "none":
      return null;
    case "sends":
      return { shortLabel: "Sends", description: SEND_EVENT_DESCRIPTION };
    case "recs":
      return {
        shortLabel: "Recommendations",
        description: REC_TABLE_DESCRIPTION,
      };
    case "rolling_30d_users":
      return {
        shortLabel: "Active users (30d)",
        description: ROLLING_30D_USERS_DESCRIPTION,
      };
  }
}

export function getMetricSourceTooltip(
  numerator: MetricNumerator,
  denominator: MetricDenominator,
): string {
  const num = getNumeratorSource(numerator);
  const denom = getDenominatorSource(denominator);
  if (!denom) {
    return num.description;
  }
  return `${num.shortLabel} — ${num.description} ${denom.shortLabel} — ${denom.description}`;
}
